@use "@css/variables";

$field-height: 44px;

.card {
  background: white;
  border: 1px solid var(--beigedark);
  border-radius: 16px;
  box-shadow: 0 10px 30px -12px rgba(0, 0, 0, 0.08);
  overflow: hidden;

  .body {
    padding: 1.5rem;
  }

  .title {
    display: flex;
    flex-direction: column;
    gap: .25rem;
    padding-bottom: 1.25rem;
    margin-bottom: 1.5rem;
    border-bottom: 1px solid var(--beigedark);

    h2 {
      font-size: 1.35rem;
      font-weight: 600;
      margin: 0;
    }

    p {
      margin: 0;
      color: var(--gray);
    }
  }

  .fields {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 1.25rem;

    // PersonInput brings its own grids, align their spacing with ours
    :global(.grid) {
      column-gap: 1.25rem;
      row-gap: 1.25rem;
    }
  }

  label {
    display: block;
    margin-bottom: .375rem;
    font-weight: 500;
  }

  // Give every field type (text, date, native select, react-select) the same height and look
  input:not([type=checkbox]):not([type=radio]):not(:global(.rs__input)),
  select {
    box-sizing: border-box;
    height: $field-height;
    padding: 0 .875rem;
    border: 1px solid var(--beigedarker) !important;
    border-radius: 8px;
    background-color: white;
    line-height: normal;
    transition: border-color .15s ease, box-shadow .15s ease;
  }

  select {
    appearance: none;
    padding-right: 2.5rem;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1.5l5 5 5-5' fill='none' stroke='%237C7C7C' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right .875rem center;
    cursor: pointer;
  }

  :global(.rs-container) {
    max-width: none;
  }

  :global(.rs__control) {
    box-sizing: border-box;
    height: $field-height;
    min-height: $field-height;
    border: 1px solid var(--beigedarker) !important;
    border-radius: 8px;
    transition: border-color .15s ease, box-shadow .15s ease;
  }

  :global(.rs__value-container) {
    padding: 0 .875rem;
  }

  :global(.rs__dropdown-indicator) {
    background: transparent;
    color: var(--gray);
    padding: 0 .75rem;
  }

  input:not([type=checkbox]):not([type=radio]):not(:global(.rs__input)):focus,
  select:focus,
  :global(.rs__control--is-focused) {
    border-color: var(--primary) !important;
    box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary) 15%, transparent) !important;
  }

  .footer {
    display: flex;
    flex-direction: column-reverse;
    align-items: stretch;
    gap: 1rem;
    padding: 1.25rem 1.5rem;
    background: var(--beigelight);
    border-top: 1px solid var(--beigedark);

    p {
      margin: 0;
      font-size: .9em;
      color: var(--gray);
    }

    .actions {
      display: flex;
      flex-direction: column;
      gap: .75rem;
    }
  }
}

@media only screen and (min-width: variables.$md-breakpoint) {
  .card {
    .body {
      padding: 2rem 2.25rem;
    }

    .footer {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 1.25rem 2.25rem;

      .actions {
        flex-direction: row;
      }
    }
  }
}
